<template>
  <div>
    <div class="student-title">身份证照片</div>
    <div class="student-card">
      <div class="student-card-uploader">
        <!--已毕业身份证处理-->
        <template v-if="!uploaderDataVisible">
          <template
            v-if="
              personCardInfo.frontCard &&
              personCardInfo.frontCard.auditstatus === 2
            "
          >
            <div class="student-card-front success">
              <img
                :src="concatImageUrl(personCardInfo.frontCard.url, 243, 153)"
              />
            </div>
            <div class="student-card-success">
              <img src="../../assets/images/identity-success.png" />
            </div>
          </template>
          <template v-else>
            <div
              class="student-card-front"
              style="border: 1px solid #ccc; border-radius: 6px"
            >
              <p style="line-height: 150px; color: #999">未上传证件照</p>
            </div>
          </template>
        </template>
        <!-- 未毕业身份证相关处理 -->
        <template
          v-else-if="
            personCardInfo.frontCard &&
            Object.keys(personCardInfo.frontCard).length > 0 &&
            personCardInfo.frontCard.auditstatus === 2
          "
        >
          <div class="student-card-front success">
            <img
              :src="concatImageUrl(personCardInfo.frontCard.url, 243, 153)"
            />
          </div>
          <div class="student-card-success">
            <img src="../../assets/images/identity-success.png" />
          </div>
        </template>
        <template
          v-else-if="
            personCardInfo.frontCard &&
            Object.keys(personCardInfo.frontCard).length > 0 &&
            (personCardInfo.frontCard.auditstatus === 1 ||
              personCardInfo.frontCard.auditstatus === 0)
          "
        >
          <div class="student-card-front success">
            <img
              :src="concatImageUrl(personCardInfo.frontCard.url, 243, 153)"
            />
            <div class="student-card-again">
              <p v-if="personCardInfo.frontCard.auditstatus === 1">审核中</p>
              <p v-else>审核未通过</p>
              <Upload
                :action="uploaderConfig.uploaderUrl"
                :headers="uploaderConfig.uploaderHeaer"
                :data="uploaderConfig.uploaderFrontData"
                :max-size="1024 * 10"
                :on-exceeded-size="handleMaxSizeError"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                :on-format-error="handleFormatError"
                :before-upload="handleFrontBefore"
                :on-success="handleFrontSuccess"
                :show-upload-list="false"
              >
                <Button type="default" shape="circle" ghost>重新上传</Button>
              </Upload>
            </div>
          </div>
        </template>
        <template v-else>
          <Upload
            :action="uploaderConfig.uploaderUrl"
            :headers="uploaderConfig.uploaderHeaer"
            :data="uploaderConfig.uploaderFrontData"
            :max-size="1024 * 10"
            :on-exceeded-size="handleMaxSizeError"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            :on-format-error="handleFormatError"
            :before-upload="handleFrontBefore"
            :on-success="handleFrontSuccess"
            :show-upload-list="false"
          >
            <div class="student-card-front">
              <img src="../../assets/images/identity-card-a.png" />
            </div>
          </Upload>
        </template>
        <p>身份证人像面</p>
      </div>
      <div class="student-card-uploader">
        <!--已毕业身份证处理-->
        <template v-if="!uploaderDataVisible">
          <template
            v-if="
              personCardInfo.backCard &&
              personCardInfo.backCard.auditstatus === 2
            "
          >
            <div class="student-card-front success">
              <img
                :src="concatImageUrl(personCardInfo.backCard.url, 243, 153)"
              />
            </div>
            <div class="student-card-success">
              <img src="../../assets/images/identity-success.png" />
            </div>
          </template>
          <template v-else>
            <div
              class="student-card-front"
              style="border: 1px solid #ccc; border-radius: 6px"
            >
              <p style="line-height: 150px; color: #999">未上传证件照</p>
            </div>
          </template>
        </template>
        <!-- 未毕业身份证相关处理 -->
        <template
          v-else-if="
            personCardInfo.backCard &&
            Object.keys(personCardInfo.backCard).length > 0 &&
            personCardInfo.backCard.auditstatus === 2
          "
        >
          <div class="student-card-front success">
            <img :src="concatImageUrl(personCardInfo.backCard.url, 243, 153)" />
          </div>
          <div class="student-card-success">
            <img src="../../assets/images/identity-success.png" />
          </div>
        </template>
        <template
          v-else-if="
            personCardInfo.backCard &&
            Object.keys(personCardInfo.backCard).length > 0 &&
            (personCardInfo.backCard.auditstatus === 1 ||
              personCardInfo.backCard.auditstatus === 0)
          "
        >
          <div class="student-card-front success">
            <img :src="concatImageUrl(personCardInfo.backCard.url, 243, 153)" />
            <div class="student-card-again">
              <p v-if="personCardInfo.backCard.auditstatus === 1">审核中</p>
              <p v-else>审核未通过</p>
              <Upload
                :action="uploaderConfig.uploaderUrl"
                :headers="uploaderConfig.uploaderHeaer"
                :data="uploaderConfig.uploaderBackData"
                :max-size="1024 * 10"
                :on-exceeded-size="handleMaxSizeError"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                :on-format-error="handleFormatError"
                :before-upload="handleBackBefore"
                :on-success="handleBackSuccess"
                :show-upload-list="false"
              >
                <Button type="default" shape="circle" ghost>重新上传</Button>
              </Upload>
            </div>
          </div>
        </template>
        <template v-else>
          <Upload
            :action="uploaderConfig.uploaderUrl"
            :headers="uploaderConfig.uploaderHeaer"
            :data="uploaderConfig.uploaderBackData"
            :max-size="1024 * 10"
            :on-exceeded-size="handleMaxSizeError"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            :on-format-error="handleFormatError"
            :before-upload="handleBackBefore"
            :on-success="handleBackSuccess"
            :show-upload-list="false"
          >
            <div class="student-card-front">
              <img src="../../assets/images/identity-card-a.png" />
            </div>
          </Upload>
        </template>
        <p>身份证国微面</p>
      </div>
    </div>
    <div class="student-person">
      <div class="student-person-title">个人照片</div>
      <!--已毕业个人照处理-->
      <template v-if="!uploaderDataVisible">
        <template
          v-if="personCardInfo.photo && personCardInfo.photo.auditstatus === 2"
        >
          <div class="student-person-photo">
            <div class="student-person-btn success">
              <img :src="concatImageUrl(personCardInfo.photo.url, 60, 80)" />
              <div class="student-person-success">
                <img src="../../assets/images/identity-success-sm.png" />
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="student-person-photo">
            <div
              class="student-person-btn"
              style="border-color: #ccc; color: #999"
            >
              未上传
            </div>
          </div>
        </template>
      </template>
      <!-- 未毕业个人照相关处理 -->
      <template
        v-else-if="
          personCardInfo.photo &&
          Object.keys(personCardInfo.photo).length > 0 &&
          personCardInfo.photo.auditstatus === 2
        "
      >
        <div class="student-person-photo">
          <div class="student-person-btn success">
            <img :src="concatImageUrl(personCardInfo.photo.url, 60, 80)" />
            <div class="student-person-success">
              <img src="../../assets/images/identity-success-sm.png" />
            </div>
          </div>
        </div>
      </template>
      <template
        v-else-if="
          personCardInfo.photo &&
          Object.keys(personCardInfo.photo).length > 0 &&
          (personCardInfo.photo.auditstatus === 1 ||
            personCardInfo.photo.auditstatus === 0)
        "
      >
        <div class="student-person-photo">
          <div class="student-person-btn success">
            <img :src="concatImageUrl(personCardInfo.photo.url, 60, 90)" />
            <div class="student-person-audit">
              <p v-if="personCardInfo.photo.auditstatus === 1">审核中</p>
              <p v-else>审核失败</p>
            </div>
          </div>
        </div>
        <div class="student-person-text">
          <Upload
            :action="uploaderConfig.uploaderUrl"
            :headers="uploaderConfig.uploaderHeaer"
            :data="uploaderConfig.uploaderPhotoData"
            :max-size="1024 * 10"
            :on-exceeded-size="handleMaxSizeError"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            :on-format-error="handleFormatError"
            :before-upload="handlePhotoBefore"
            :on-success="handlePhotoSuccess"
            :show-upload-list="false"
          >
            <Button type="primary" shape="circle">重新上传</Button>
          </Upload>
        </div>
      </template>
      <template v-else>
        <div class="student-person-photo">
          <Upload
            :action="uploaderConfig.uploaderUrl"
            :headers="uploaderConfig.uploaderHeaer"
            :data="uploaderConfig.uploaderPhotoData"
            :max-size="1024 * 10"
            :on-exceeded-size="handleMaxSizeError"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            :on-format-error="handleFormatError"
            :before-upload="handlePhotoBefore"
            :on-success="handlePhotoSuccess"
            :show-upload-list="false"
          >
            <div class="student-person-btn">
              <Icon type="md-add" size="20" />
            </div>
          </Upload>
        </div>
        <div class="student-person-text">点击上传免冠彩照</div>
      </template>
    </div>
    <div class="student-title">学籍信息</div>
    <div class="student-body clearfix">
      <div class="table-tr">
        <div class="table-th">学号</div>
        <div class="table-td">{{ schoolRollInfo.studentId }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">姓名</div>
        <div class="table-td">{{ schoolRollInfo.studentName }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">性别</div>
        <div class="table-td">{{ schoolRollInfo.sex }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">手机号</div>
        <div class="table-td">{{ schoolRollInfo.mobile }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">学籍状态</div>
        <div class="table-td">{{ schoolRollInfo.status }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">专业代码</div>
        <div class="table-td">{{ schoolRollInfo.MajorID }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">专业名称</div>
        <div class="table-td">{{ schoolRollInfo.majorName }}</div>
      </div>
      <div
        class="table-tr"
        v-for="(item, index1) in schoolRollInfo.feidListMajor"
        :key="index1"
      >
        <template v-if="item.type == 'uploadImg'">
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">
            <a
              href="javascript:;"
              style="color: #57a3f3; text-decoration: underline"
              @click="item.attachVisible = true"
              >查看图片</a
            >
          </div>
          <Modal
            v-model="item.attachVisible"
            title="查看图片"
            width="600"
            footer-hide
          >
            <div class="picture-view clearfix">
              <p v-for="(pic, pici1) in item.fieldName" :key="pici1">
                <a
                  :href="concatImageUrl(pic)"
                  target="_blank"
                  title="点击查看大图"
                >
                  <img :src="concatImageUrl(pic, 150, 150)" />
                </a>
              </p>
            </div>
          </Modal>
        </template>
        <template v-else-if="item.type == 'uploadFile'">
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">
            <a
              href="javascript:;"
              style="color: #57a3f3; text-decoration: underline"
              @click="item.attachVisible = true"
              >查看文件</a
            >
          </div>
          <Modal
            v-model="item.attachVisible"
            title="查看文件"
            width="600"
            footer-hide
          >
            <div class="file-view">
              <p
                class="file-item"
                v-for="(file, filei1) in item.fieldName"
                :key="filei1"
              >
                <a
                  :href="concatImageUrl(file.url)"
                  target="_blank"
                  title="点击下载"
                >
                  <span style="font-size: 1.8rem; margin-right: 5px">●</span>
                  {{ file.name }}
                </a>
              </p>
            </div>
          </Modal>
        </template>
        <template v-else>
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">{{ item.fieldName }}</div>
        </template>
      </div>
      <div class="table-tr">
        <div class="table-th">班级名称</div>
        <div class="table-td">{{ schoolRollInfo.gradeName }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">批次</div>
        <div class="table-td">{{ schoolRollInfo.batch }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">开班时间</div>
        <div class="table-td">{{ schoolRollInfo.startTime }}</div>
      </div>
      <div class="table-tr">
        <div class="table-th">班主任老师</div>
        <div class="table-td">{{ schoolRollInfo.adminName }}</div>
      </div>
      <div>
        <div
          class="table-tr"
          v-for="(item, index2) in schoolRollInfo.feidListClass"
          :key="index2"
        >
          <template v-if="item.type == 'uploadImg'">
            <div class="table-th">{{ item.label }}</div>
            <div class="table-td">
              <a
                href="javascript:;"
                style="color: #57a3f3; text-decoration: underline"
                @click="item.attachVisible = true"
                >查看图片</a
              >
            </div>
            <Modal
              v-model="item.attachVisible"
              title="查看图片"
              width="600"
              footer-hide
            >
              <div class="picture-view clearfix">
                <p v-for="(pic, pici2) in item.fieldName" :key="pici2">
                  <a
                    :href="concatImageUrl(pic)"
                    target="_blank"
                    title="点击查看大图"
                  >
                    <img :src="concatImageUrl(pic, 150, 150)" />
                  </a>
                </p>
              </div>
            </Modal>
          </template>
          <template v-else-if="item.type == 'uploadFile'">
            <div class="table-th">{{ item.label }}</div>
            <div class="table-td">
              <a
                href="javascript:;"
                style="color: #57a3f3; text-decoration: underline"
                @click="item.attachVisible = true"
                >查看文件</a
              >
            </div>
            <Modal
              v-model="item.attachVisible"
              title="查看文件"
              width="600"
              footer-hide
            >
              <div class="file-view">
                <p
                  class="file-item"
                  v-for="(file, filei2) in item.fieldName"
                  :key="filei2"
                >
                  <a
                    :href="concatImageUrl(file.url)"
                    target="_blank"
                    title="点击下载"
                  >
                    <span style="font-size: 1.8rem; margin-right: 5px">●</span>
                    {{ file.name }}
                  </a>
                </p>
              </div>
            </Modal>
          </template>
          <template v-else>
            <div class="table-th">{{ item.label }}</div>
            <div class="table-td">{{ item.fieldName }}</div>
          </template>
        </div>
      </div>
      <div class="table-tr" v-if="schoolRollColumns % 2 == 1">
        <div class="table-th">&nbsp;</div>
        <div class="table-td">&nbsp;</div>
      </div>
    </div>
    <div class="student-title">其它信息</div>
    <ul class="student-body">
      <li
        class="table-tr"
        v-for="(item, index3) in schoolRollInfo.feidList"
        :key="index3"
      >
        <template v-if="item.type == 'uploadImg'">
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">
            <a
              href="javascript:;"
              style="color: #57a3f3; text-decoration: underline"
              @click="item.attachVisible = true"
              >查看图片</a
            >
          </div>
          <Modal
            v-model="item.attachVisible"
            title="查看图片"
            width="600"
            footer-hide
          >
            <div class="picture-view clearfix">
              <p v-for="(pic, pici3) in item.fieldName" :key="pici3">
                <a
                  :href="concatImageUrl(pic)"
                  target="_blank"
                  title="点击查看大图"
                >
                  <img :src="concatImageUrl(pic, 150, 150)" />
                </a>
              </p>
            </div>
          </Modal>
        </template>
        <template v-else-if="item.type == 'uploadFile'">
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">
            <a
              href="javascript:;"
              style="color: #57a3f3; text-decoration: underline"
              @click="item.attachVisible = true"
              >查看文件</a
            >
          </div>
          <Modal
            v-model="item.attachVisible"
            title="查看文件"
            width="600"
            footer-hide
          >
            <div class="file-view">
              <p
                class="file-item"
                v-for="(file, filei3) in item.fieldName"
                :key="filei3"
              >
                <a
                  :href="concatImageUrl(file.url)"
                  target="_blank"
                  title="点击下载"
                >
                  <span style="font-size: 1.8rem; margin-right: 5px">●</span>
                  {{ file.name }}
                </a>
              </p>
            </div>
          </Modal>
        </template>
        <template v-else>
          <div class="table-th">{{ item.label }}</div>
          <div class="table-td">{{ item.fieldName }}</div>
        </template>
      </li>
    </ul>
    <div class="student-title" style="margin: 20px 0">
      <span style="margin-right: 20px">个人资料</span>
      <Button
        type="primary"
        shape="circle"
        style="width: 80px"
        @click="alertPersonData"
        v-show="uploaderDataVisible"
        >上传</Button
      >
    </div>
    <div class="student-data">
      <div class="table-tr">
        <div class="table-th">文件名称</div>
        <div class="table-th">文件</div>
        <div class="table-th">操作</div>
      </div>
      <div
        v-if="!personDataList || personDataList.length <= 0"
        style="border-top: 1px solid #ccc; text-align: center; padding: 8px"
      >
        暂无数据...
      </div>
      <div
        class="table-tr"
        v-for="(item, personIndex) in personDataList"
        :key="personIndex"
      >
        <div class="table-td" :title="item.filename">
          {{ item.filename }}
        </div>
        <div class="table-td">{{ item.name }}</div>
        <div class="table-td">
          <a
            v-if="
              item.url.indexOf('jpg') >= 0 ||
              item.url.indexOf('png') >= 0 ||
              item.url.indexOf('gif') >= 0
            "
            :href="
              concatImageUrl(item.url) +
              '?response-content-type=application/octet-stream'
            "
            >下载</a
          >
          <a v-else :href="concatImageUrl(item.url)">下载</a>
          <Poptip
            confirm
            title="您确定要删除么?"
            @on-ok="deletePersonData(item)"
            style="text-align: left"
          >
            <a href="javascript:;" v-show="uploaderDataVisible" title="删除"
              >删除</a
            >
          </Poptip>
        </div>
      </div>
    </div>

    <!-- 学籍管理上传文件   -->
    <Modal v-model="personDataVisible" title="上传资料" width="360">
      <div class="student-modal-upload">
        <div class="upload-item">
          <Input v-model="personData.fileName" placeholder="请输入文件名称" />
        </div>
        <div class="upload-item">
          <Spin v-if="uploaderLoading" fix>
            <Icon type="ios-loading" size="22" class="spin-icon-load"></Icon>
            <div style="margin-top: 5px">上传中</div>
          </Spin>
          <Upload
            :action="uploaderConfig.uploaderFileUrl"
            :headers="uploaderConfig.uploaderHeaer"
            :max-size="1024 * 50"
            :on-exceeded-size="handleMaxSizeError"
            :format="[
              'jpg',
              'jpeg',
              'png',
              'gif',
              'doc',
              'docx',
              'ppt',
              'pptx',
              'xls',
              'xlsx',
              'zip',
              'rar',
              '7z',
              'pdf',
            ]"
            :on-format-error="handleFormatFileError"
            :before-upload="handleFileBefore"
            :on-success="handleFileSuccess"
            :show-upload-list="false"
            ref="uploadFile"
          >
            <div class="upload-file-btn">
              <Icon type="md-add" size="32" color="#0192e6" />
              <p>
                支持文档格式：jpg/png/doc/ppt/excel/pdf/rar/zip<br />(限50M以内)
              </p>
            </div>
          </Upload>
        </div>
        <div class="upload-item" v-if="personData.name">
          <div class="upload-file-list">{{ personData.name }}</div>
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="default" @click="personDataVisible = false">取消</Button>
        <Button
          type="success"
          @click="savePersonData()"
          style="margin-left: 20px"
          >确定上传</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  props: {
    gradeInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      personCardInfo: {
        frontCard: {
          auditstatus: -1,
          url: "",
        },
        backCard: {
          auditstatus: -1,
          url: "",
        },
        photo: {
          auditstatus: -1,
          url: "",
        },
      },
      personDataVisible: false,
      personData: {
        name: "",
        url: "",
        fileName: "",
        size: "",
      },
      personDataList: [],
      schoolRollInfo: {},
      schoolRollColumns: 1,
      uploaderConfig: {
        uploaderUrl: process.env.VUE_APP_API_URL + "/rest/addGrades",
        uploaderFileUrl: process.env.VUE_APP_API_URL + "/rest/uploadGradesFile",
        uploaderHeaer: {
          Authorization: "Beego aHVhaGFuOmJlZWdvMjAxNQ==",
        },
        uploaderFrontData: {
          srfid: 0,
          agencyid: 0,
          paperstype: 1,
        },
        uploaderBackData: {
          srfid: 0,
          agencyid: 0,
          paperstype: 2,
        },
        uploaderPhotoData: {
          srfid: 0,
          agencyid: 0,
          paperstype: 3,
        },
      },
      uploaderDataVisible: false,
      uploaderLoading: false,
    };
  },
  mounted() {
    this.initUploaderData();
    this.getSchoolRollInfo();
    this.getPersonGrades(1);
    this.getPersonGrades(2);
  },
  methods: {
    getSchoolRollInfo() {
      user
        .getSchoolRollInfo(this.gradeInfo.gradeCode, this.loginUser.userId)
        .then((res) => {
          //console.log("schoolRoll", res);
          if (res.status === 1) {
            this.schoolRollInfo = res.data;
            this.schoolRollInfo.feidList.forEach((item) => {
              this.$set(item, "attachVisible", false);
            });
            this.schoolRollInfo.feidListClass.forEach((item) => {
              this.$set(item, "attachVisible", false);
            });
            this.schoolRollInfo.feidListMajor.forEach((item) => {
              this.$set(item, "attachVisible", false);
            });
            if (
              this.schoolRollInfo.feidList &&
              this.schoolRollInfo.feidList.length % 2 == 1
            ) {
              this.schoolRollInfo.feidList.push({ label: "", fieldName: "" });
            }
            this.schoolRollColumns =
              1 +
              this.schoolRollInfo.feidList.length +
              this.schoolRollInfo.feidListClass.length +
              this.schoolRollInfo.feidListMajor.length;
          }
        });
    },
    //获取证件信息（身份证、生活照、其它资料）
    //type--1：基础证件(身份证、个人照)2：其它证件
    getPersonGrades(type) {
      user.getPersonGrades(this.gradeInfo.srfId, type).then((res) => {
        //console.log("personcard" + type, res);
        if (res.status === 1) {
          if (type == 1) {
            const cardList = res.data.gradesList;
            if (cardList.length > 0) {
              //1：基础证件
              const frontCard = cardList.find((m) => m.paperstype === 1);
              if (frontCard) {
                this.personCardInfo.frontCard = frontCard;
              }
              const backCard = cardList.find((m) => m.paperstype === 2);
              if (backCard) {
                this.personCardInfo.backCard = backCard;
              }
              const photo = cardList.find((m) => m.paperstype === 3);
              if (photo) {
                this.personCardInfo.photo = photo;
              }
            }
          } else {
            //其它证件
            this.personDataList = res.data.gradesList;
            this.uploaderDataVisible =
              res.data.isGraduation === 0 ? true : false;
          }
        }
      });
    },
    //保存用户上传的其它资料
    savePersonData() {
      if (!this.personData.fileName) {
        this.$Message.error("请输入文件名称~");
        return;
      }
      if (!this.personData.url) {
        this.$Message.error("请上传您的资料~");
        return;
      }
      user
        .savePersonFile(
          this.gradeInfo.srfId,
          this.siteConfig.agencyId,
          this.personData.url,
          this.personData.fileName,
          this.personData.name,
          this.personData.size
        )
        .then((res) => {
          //console.log("savePersonData", res);
          if (res.status === 1) {
            this.personDataVisible = false;
            this.$Message.success("资料上传成功");
            this.personData.name = "";
            this.personData.fileName = "";
            this.personData.url = "";
            this.getPersonGrades(2);
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    //取消上传操作
    alertPersonData() {
      this.personData.name = "";
      this.personData.fileName = "";
      this.personData.url = "";
      this.uploaderLoading = false;
      this.personDataVisible = true;
    },
    deletePersonData(item) {
      user.deletePersonFile(item.id).then((res) => {
        if (res.status === 1) {
          this.$Message.success("资料删除成功");
          this.getPersonGrades(2);
        } else {
          this.$Message.success("资料删除失败");
        }
      });
    },
    //初始化学籍上传数据
    initUploaderData() {
      //身份证头像面
      this.uploaderConfig.uploaderFrontData.srfid = this.gradeInfo.srfId;
      this.uploaderConfig.uploaderFrontData.agencyid = this.siteConfig.agencyId;
      //身份证国徽面
      this.uploaderConfig.uploaderBackData.srfid = this.gradeInfo.srfId;
      this.uploaderConfig.uploaderBackData.agencyid = this.siteConfig.agencyId;
      //个人照片
      this.uploaderConfig.uploaderPhotoData.srfid = this.gradeInfo.srfId;
      this.uploaderConfig.uploaderPhotoData.agencyid = this.siteConfig.agencyId;
    },
    handleFrontBefore(file) {
      if (this.personCardInfo.frontCard.id) {
        this.uploaderConfig.uploaderFrontData.id = this.personCardInfo.frontCard.id;
      }
    },
    handleFrontSuccess(res) {
      //console.log("frontUploaderSuccess", res);
      if (res.status === 1) {
        // this.personCardInfo.frontCard.auditstatus = 1;
        // this.personCardInfo.frontCard.url = res.data;
        this.getPersonGrades(1);
      } else {
        this.$Message.error(res.message);
      }
    },
    handleBackBefore(file) {
      if (this.personCardInfo.backCard.id) {
        this.uploaderConfig.uploaderBackData.id = this.personCardInfo.backCard.id;
      }
    },
    handleBackSuccess(res) {
      //console.log("backUploaderSuccess", res);
      if (res.status === 1) {
        // this.personCardInfo.backCard.auditstatus = 1;
        // this.personCardInfo.backCard.url = res.data;
        this.getPersonGrades(1);
      } else {
        this.$Message.error(res.message);
      }
    },
    handlePhotoBefore(file) {
      if (this.personCardInfo.photo.id) {
        this.uploaderConfig.uploaderPhotoData.id = this.personCardInfo.photo.id;
      }
    },
    handlePhotoSuccess(res) {
      //console.log("backUploaderSuccess", res);
      if (res.status === 1) {
        // this.personCardInfo.photo.auditstatus = 1;
        // this.personCardInfo.photo.url = res.data;
        this.getPersonGrades(1);
      } else {
        this.$Message.error(res.message);
      }
    },
    handleFileBefore(file) {
      this.uploaderLoading = true;
    },
    handleFileSuccess(res, file) {
      //console.log("personDataSuccess", res);
      if (res.Status === 1) {
        this.personData.url = res.Url;
        this.personData.name = res.Name;
        this.personData.size = res.Size;
      } else {
        this.$Message.error(res.message);
      }
      this.uploaderLoading = false;
    },
    handleMaxSizeError(file) {
      this.$Message.error("上传文件超过最大上传大小~");
      this.uploaderLoading = false;
    },
    handleFormatError(file) {
      this.$Message.error(
        "请上传图片文件，仅支持 jpg/jpeg/png/gif 格式的图片~"
      );
      this.uploaderLoading = false;
    },
    handleFormatFileError(file) {
      this.$Message.error("请上传正确的文件，仅支持说明中的文件格式~");
      this.uploaderLoading = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
.student-title {
  font-weight: bold;
  font-size: 16px;
}
.student-card {
  width: 660px;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  .student-card-uploader {
    position: relative;
    .student-card-front,
    .student-card-back {
      width: 267px;
      height: 177px;
      &.success {
        border-radius: 10px;
        overflow: hidden;
        text-align: center;
        img {
          border-radius: 10px;
          margin-top: 7px;
          display: inline-block;
        }
      }
    }
    .student-card-success {
      position: absolute;
      top: 50px;
      right: -40px;

      width: 80px;
      height: 80px;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .student-card-again {
      position: absolute;
      left: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
      width: 267px;
      height: 177px;
      border-radius: 10px;
      text-align: center;
      p {
        color: #fff;
        font-size: 18px;
        padding-top: 50px;
        padding-bottom: 20px;
      }
    }
    p {
      margin-top: 10px;
      text-align: center;
    }
  }
}
.student-person {
  padding: 30px 0;
  display: flex;
  align-items: center;
  .student-person-title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .student-person-photo {
    width: 90px;
    .student-person-btn {
      position: relative;
      display: flex;
      width: 60px;
      height: 80px;
      border: 1px dashed #ccc;
      border-radius: 6px;
      align-items: center;
      justify-content: center;
      & > img {
        border-radius: 6px;
        max-width: 60px;
        max-height: 80px;
      }
      &.success {
        border: none;
      }
      cursor: pointer;
      i {
        color: #999;
      }
      &:hover {
        border-color: #0092e6;
        i {
          color: #0092e6;
        }
      }
      .student-person-audit {
        position: absolute;
        left: 0;
        top: 0;
        width: 60px;
        height: 80px;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
      .student-person-success {
        position: absolute;
        right: -36px;
        top: 22px;
        width: 48px;
        height: 48px;
        img {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
  .student-person-text {
    flex: 1;
    color: #666;
  }
}
.student-modal-upload {
  width: 100%;
  .upload-item {
    width: 260px;
    margin: 10px auto;
    position: relative;
  }
  .upload-file-btn {
    border: 1px dashed #ccc;
    border-radius: 6px;
    background: #f5f5f5;
    text-align: center;
    padding: 40px 20px 10px 20px;
    p {
      margin-top: 10px;
      color: #999;
      line-height: 1.6;
      text-align: left;
    }
  }
  .upload-file-list {
    background: #f5f5f5;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 12px;
  }
}
.student-data {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  .table-tr {
    display: flex;
    &:nth-child(2n) {
      background: #d5f0ff;
    }
    .table-th {
      font-weight: bold;
    }
    .table-th,
    .table-td {
      padding: 5px 5px;
      text-align: center;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      margin-top: -1px;
      margin-left: -1px;
      .ellipsis();
      &:first-child {
        width: 200px;
      }
      &:nth-child(2) {
        width: 500px;
      }
      &:last-child {
        width: 120px;
        a {
          margin: 0 8px;
          &:first-child {
            color: #0092e6;
          }
          &:last-child {
            color: #ff4f4f;
          }
        }
      }
    }
  }
}
.student-body {
  border-radius: 6px;
  border: 1px solid #ccc;
  overflow: hidden;
  margin: 10px auto;
  // display: flex;
  // flex-wrap: wrap;

  .table-tr {
    float: left;
    width: 50%;
    height: 37px;
    display: flex;
    &:nth-child(4n + 3) {
      background-color: #d5f0ff;
    }
    &:nth-child(4n) {
      background-color: #d5f0ff;
    }
    .table-th {
      margin: -1px 0 0 -1px;
      padding: 8px 10px;
      width: 30%;
      font-weight: bold;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      display: flex;
      align-items: center;
      .ellipsis();
    }
    .table-td {
      margin: -1px 0 0 -1px;
      padding: 8px 10px;
      flex: 1;
      border-left: 1px solid #ccc;
      border-top: 1px solid #ccc;
      .ellipsis();
    }
  }
}
.picture-view {
  width: 100%;
  padding-top: 20px;
  p {
    width: 33.3%;
    float: left;
    text-align: center;
    margin-bottom: 20px;
  }
  img {
    margin: 0 auto;
    width: 158px;
    padding: 3px;
    border: 1px solid #ccc;
  }
}
.file-view {
  width: 100%;
  min-height: 200px;
  .file-item {
    text-align: left;
  }
}
</style>